/* eslint-disable no-unused-vars */
import Swiper, { Navigation, A11y } from 'swiper/core';

Swiper.use([Navigation, A11y]);

const seeAlso = () => {
    const swiper = new Swiper('.swiper-see-also', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 1.4,
        spaceBetween: 20,
        watchOverflow: true,
        watchSlidesVisibility: true,
        // loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1025: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
    });
};
seeAlso();
